// extracted by mini-css-extract-plugin
module.exports = {"select":"ProductColorDropdown_select__6EnU_","selectPanel":"ProductColorDropdown_selectPanel__K95fQ"};